type Mapping = {
  [x: string]: any;
};

export const iconMapping: Mapping = {
  stader: '/assets/images/stader-icon.svg',
};
